import { render, staticRenderFns } from "./TableActionButton.vue?vue&type=template&id=1f1b1c9c&"
import script from "./TableActionButton.vue?vue&type=script&lang=js&"
export * from "./TableActionButton.vue?vue&type=script&lang=js&"
import style0 from "./TableActionButton.vue?vue&type=style&index=0&id=1f1b1c9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports